import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "collection", "collectionTemplates", "storyTemplates", "lazyAfter"];
import React from 'react';
import { InfiniteScroll } from './infinite-scroll';
import { string, object, func } from 'prop-types';
import { StoryNotImplemented, CollectionNotImplemented, renderCollectionItem } from './impl/collection-impl';
/**
 * This component can be used to render a collection, but with the components being lazy. This takes all the same options as Collection, but with a `lazyAfter` prop.
 * This Component also accepts extra props, which will be passed down to collection templates.
 *
 * This Component is similar to {@link Collection}. Please see that for a more detailed example.
 *
 * Note: This does not accept `interstitial` items (yet). And home page items are not hidden after being rendered
 *
 * ```javascript
 * import { LazyCollection } from '@quintype/components'
 *
 * // collection = Collection.getCollectionBySlug(client, 'home', {}, {depth: 1})
 *
 * <LazyCollection collection={collection}
 *                 collectionTemplates={collectionTemplates}
 *                 storyTemplates={storyTemplates}
 *                 lazyAfter={3}
 *                 extraProp="some prop" />
 *
 * ```
 * @category Collection Page
 * @component
 */

export function LazyCollection(_ref) {
  var className = _ref.className,
      collection = _ref.collection,
      collectionTemplates = _ref.collectionTemplates,
      storyTemplates = _ref.storyTemplates,
      lazyAfter = _ref.lazyAfter,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    render: function render(_ref2) {
      var index = _ref2.index;
      return renderCollectionItem(collection.items[index], index, collectionTemplates, storyTemplates, otherProps);
    },
    items: collection.items,
    loadNext: function loadNext() {
      return [];
    },
    initiallyShow: lazyAfter,
    neverHideItem: true,
    showAllOnLegacyBrowser: true // No Op
    ,
    focusCallbackAt: 20,
    onFocus: function onFocus() {}
  }));
}
LazyCollection.defaultProps = {
  collectionTemplates: function collectionTemplates() {
    return CollectionNotImplemented;
  },
  storyTemplates: function storyTemplates() {
    return StoryNotImplemented;
  }
};